import { observer } from 'mobx-react-lite'
import { Typography } from 'shared/ui'
import { SmartCallActionNode } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/Action/ui/SmartCallActionNode/SmartCallActionNode'
import { type ISmartCallNodeProps } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/ui/SmartCallFlowBuilderUi'
import { useSmartCallFlowBuilderContext } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/context'
import { AICallingAgentStore } from '../../store/AICallingAgentStore'

export const AICallingAgentNode = observer((props: ISmartCallNodeProps) => {
  const { id } = props
  const { getActionById } = useSmartCallFlowBuilderContext()
  const store = getActionById(id)
  if (!(store instanceof AICallingAgentStore)) return null

  const { aiCallingAgent } = store

  return (
    <SmartCallActionNode
      iconProps={AICallingAgentStore.iconProps}
      title={AICallingAgentStore.title}
      placeholder={'Engage with AI Agent'}
      content={
        aiCallingAgent ? (
          <Typography ariaLabel={'aiCallingAgentName'} variant={'body-md-regular'}>
            {aiCallingAgent.name}
          </Typography>
        ) : null
      }
      {...props}
    />
  )
})
